/**
 * Feedback service — writes "Tell the Build Team" notes to Hugo_Feedback.
 *
 * Document shape:
 *   { type, message, page: { path, title }, organizationId, organizationName,
 *     personaId, viewAsUid, uid, email, displayName, userAgent, viewport,
 *     appVersion, status: 'new', createdAt }
 * n8n relays new docs to Alex + Tim by email (Beta-1 plan P7-10).
 */
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export const FEEDBACK_COLLECTION = 'Hugo_Feedback';

export async function submitFeedback({
  type = 'feedback',
  message,
  user,
  organization,
  personaId = null,
  viewAsUid = null,
}) {
  const text = String(message || '').trim();
  if (!text) throw new Error('Please write a note first.');
  if (!user?.uid) throw new Error('You need to be signed in to send feedback.');

  const doc = {
    type,
    message: text,
    page: {
      path: typeof window !== 'undefined' ? window.location.pathname + window.location.search : '',
      title: typeof document !== 'undefined' ? document.title : '',
    },
    organizationId: organization?.id || null,
    organizationName: organization?.name || null,
    personaId,
    viewAsUid,
    uid: user.uid,
    email: user.email || null,
    displayName: user.displayName || null,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    viewport: typeof window !== 'undefined' ? `${window.innerWidth}x${window.innerHeight}` : '',
    appVersion: import.meta.env.VITE_APP_VERSION || null,
    status: 'new',
    createdAt: serverTimestamp(),
  };
  const ref = await addDoc(collection(db, FEEDBACK_COLLECTION), doc);
  return { id: ref.id, ...doc };
}
